import { Component, HostListener, ElementRef, ViewChild, OnInit } from '@angular/core';

import $ from 'jquery';
declare let $: any;

import { Animations, mouseEnterServices} from './animations';

import { EmailService, IMessage } from './email.service';

export interface FormModel {
  captcha?: string;
}


/*
@Directive({
  selector: '[foo]'
})
export class MyDirective {

  @Input() scrollToSelect: string;

  constructor (private _elRef: ElementRef) { }

  elementParentH = this._elRef.nativeElement.offsetParent.offsetHeight / 2;  /*
 elementHeight = this._elRef.nativeElement.innerHeight / 2;
 elementCentredTop = (this.elementParentH - this.elementHeight) + this.elementHeight;
 */                                                                         /*
  elementCentredTop = (window.innerHeight / 2) - this.elementParentH;

  @HostListener('click', ['$event.target'])
    onClick( event: MouseEvent) {

      $('html, body').animate({
        scrollTop: this.elementCentredTop
      }, 800);
      console.log(this.elementCentredTop);

    }
}
                 */
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [
    new Animations().showEjeX('showLtoRight', '-20%', 700, 700),
    new Animations().showEjeX('showLtoRight1', '-20%', 500, 500),
    new Animations().showEjeX('showLtoRight2', '-20%', 700, 700),
    new Animations().showEjeX('showLtoRight3', '-20%', 900, 900),
    new Animations().showEjeX('showLtoRight4', '-20%', 1100, 1100),

    new Animations().showEjeX('showLtoRightBanner', '-20%', 1100, 1100),

    new Animations().showEjeX('showRtoLeft', '20%', 700, 700),
    new Animations().showEjeX('showRtoLeft1', '20%', 500, 500),
    new Animations().showEjeX('showRtoLeft2', '20%', 700, 700),
    new Animations().showEjeX('showRtoLeft3', '20%', 900, 900),
    new Animations().showEjeX('showRtoLeft4', '20%', 1100, 1100),

    new Animations().showEjeX('showRtoLeftBanner', '20%', 1100, 1100),

    new Animations().showEjeY('showDtoUp', '20%', 700, 700),
    new Animations().showEjeY('showDtoUp1', '50%', 500, 500),
    new Animations().showEjeY('showDtoUp2', '50%', 800, 800),
    new Animations().showEjeY('showDtoUp3', '50%', 1000, 1000),

    new Animations().showBannerEjeY('showDtoUpBanner', 700, 700),
                                                                          /*
    new Animations().showBannerEjeY('showDtoUpBanner', '-100%', 100000, 10000),
    new Animations().showBannerEjeY2('showDtoUpBanner2', 10000, 10000),

    new Animations().showBannerEjeY('showDtoUpBanner1', 1, 1),

    new Animations().showEjeXRotate('showDtoUpRotateX', '90', 700, 700),
    new Animations().showEjeYRotate('showDtoUpRotateY', '90', 700, 700),     */

    mouseEnterServices,


    /*
    Animations2( 'showLtoRight', '-50%', 5000 ),
    Animations2( 'showRtoLeft', '50%', 700 ),

    slideIn,
        /*
    trigger('showDtoUpRotateY', [
      state('false', style({
        opacity: '0',
        transform: 'rotateX(90deg)'
      })),
      state('true', style({
        opacity: '1',
        transform: 'rotateX(0deg)'
      })),
      transition('false => true', animate('1000ms ease-out')),
      transition('true => false', animate('1000ms ease-out'))/*,
      transition('hidden <=> show', animate('900ms ease-in', keyframes([
        style({opacity: 0, transform: 'translateY(-75%)', offset: 0}),
        style({opacity: 1, transform: 'translateY(35px)',  offset: 0.5}),
        style({opacity: 1, transform: 'translateY(0)',     offset: 1.0})
      ]))),                       */  /*
    ])           */
  ]
})

export class AppComponent implements OnInit {

  public formModel: FormModel = {};
  message: IMessage = {};

  stateDashboard = false;

  statesBanner1 = 'false';
  statesBanner1_2 = 'false';
  statesBanner2 = 'false';
  statesBanner2_2 = 'false';
  statesBanner3 = 'false';
  statesBanner3_2 = 'false';
  statesBanner4 = 'false';
  statesBanner4_2 = 'false';

  textBanner = [
  'Detectamos Oportunidades',
  'Generamos Sinergia',
  'Acercamos Organizaciones',
  'Ofrecemos Resultados'
];
  arrayBanners = [];

  statesServices = 'false';
  statesNosotros= 'false';
  statesMision = 'false';
  statesVision = 'false';
  statesContact = 'false';

                          /*
  @ViewChild(MyDirective)
    set MyDirective(varDirective: MyDirective) {
      this.extraIngredient = varDirective.elementCentredTop;
    }                   */

  @ViewChild('navBar') elementNavBar: ElementRef;

  @ViewChild('secBanner') elementBanner: ElementRef;
  @ViewChild('secServicios') elementServicios: ElementRef;
  @ViewChild('secNosotros') elementNosotros: ElementRef;
  @ViewChild('secMision') elementMision: ElementRef;
  @ViewChild('secVision') elementVision: ElementRef;
  @ViewChild('secProyectos') elementProyectos: ElementRef;
  @ViewChild('secContact') elementContact: ElementRef;


  stateHoverServices1 = 'false';
  stateHoverServices2 = 'false';
  stateHoverServices3 = 'false';

  toggleStatesServices1() {
    this.stateHoverServices1 = this.stateHoverServices1 === 'true' ? 'false' : 'true';
  }
  toggleStatesServices2() {
    this.stateHoverServices2 = this.stateHoverServices2 === 'true' ? 'false' : 'true';
  }
  toggleStatesServices3() {
    this.stateHoverServices3 = this.stateHoverServices3 === 'true' ? 'false' : 'true';
  }


  toggleDashboard() {
    this.stateDashboard = this.stateDashboard === true ? false : true;
  }

  constructor(private appService: EmailService) {  }

  sendEmail(message: IMessage) {
    const ress = this.appService.sendEmail(message).subscribe(res => {
      console.log('AppComponent Success', res);
      $('#myModal').modal('show');
    }, error => {
      console.log('AppComponent Error', error);
    });
  }

  ngOnInit () {              /*

    setInterval(() => {
      this.statesBanner1 = 'true';
    }, 200);
    setInterval(() => {
      this.statesBanner2 = 'true';
    }, 4000);
    setInterval(() => {
      this.statesBanner3 = 'true';
    }, 6000);
    setInterval(() => {
      this.statesBanner4 = 'true';
    }, 8000);
                         */

    let counter = 0;
    let valid = 0;
    this.arrayBanners.push(this.textBanner[counter]);

    setInterval(() => {
      if ((this.arrayBanners.length < this.textBanner.length) && (valid === 0)) {
        counter++;
        this.arrayBanners.push(this.textBanner[counter]);
      } else if ((this.arrayBanners.length === this.textBanner.length) || (valid === 1)) {
        valid = 1;
        if ((this.arrayBanners.length === 0) && (valid === 1)) {
          valid = 0;
          counter = -1;
        } else {
          this.arrayBanners.length--;
          // this.arrayBanners.splice(0, 1);
        }
      }
    }, 2500);             /*
    setInterval(() => {
      this.statesBannerTime2 = ! this.statesBannerTime2;
      if (this.statesBannerTime2 === true ) {
        this.statesBanner = 'true';
        this.statesBanner2 = 'false';
      } else if (this.statesBannerTime2 === false ) {
        this.statesBanner = 'false';
        this.statesBanner2 = 'true';
      }
    }, 7000);           */
  }

  @HostListener('window:scroll', []) onWindowScroll() {
    const desc = 750;
    const scrollPosition = window.pageYOffset;
    // Service
    const elementServicesParent = this.elementServicios.nativeElement.offsetParent.offsetTop;
    const componentPositionService = this.elementServicios.nativeElement.offsetTop + elementServicesParent - desc;
    // Nosotros
    const elementNosotrosParent = this.elementNosotros.nativeElement.offsetParent.offsetTop;
    const componentPositionNosotros = this.elementNosotros.nativeElement.offsetTop + elementNosotrosParent - desc;
    this.elementNosotros.nativeElement.offsetParent.style.overflow = 'hidden';
    // Mision
    const elementMisionParent = this.elementMision.nativeElement.offsetParent.offsetTop;
    const componentPositionMision = this.elementMision.nativeElement.offsetTop + elementMisionParent - desc;
    this.elementMision.nativeElement.offsetParent.style.overflow = 'hidden';
    // Vision
    const elementVisionParent = this.elementVision.nativeElement.offsetParent.offsetTop;
    const componentPositionVision = this.elementVision.nativeElement.offsetTop + elementVisionParent - desc;
    this.elementVision.nativeElement.offsetParent.style.overflow = 'hidden';
    // Contact
    const elementContactParent = this.elementContact.nativeElement.offsetParent.offsetTop;
    const componentPositionContact = this.elementContact.nativeElement.offsetTop + elementContactParent - desc;

    if (scrollPosition >= componentPositionService) {
      this.statesServices = 'true';
    } else {
      this.statesServices = 'false';
    }
    if (scrollPosition >= componentPositionNosotros) {
      this.statesNosotros = 'true';
    } else {
      this.statesNosotros = 'false';
    }
    if (scrollPosition >= componentPositionMision) {
      this.statesMision = 'true';
    } else {
      this.statesMision = 'false';
    }
    if (scrollPosition >= componentPositionVision) {
      this.statesVision = 'true';
    } else {
      this.statesVision = 'false';
    }
    if (scrollPosition >= componentPositionContact) {
      this.statesContact = 'true';
    } else {
      this.statesContact = 'false';
    }
  }

  scrollAnimateTo ( types: string ) {
    const time = 1000;
    const screenWidth = window.innerWidth;

    if (screenWidth <= 1400) {
      if (types === 'inicio') {
        $('html, body').animate({
          scrollTop: 0
        }, time);
      }
      if (types === 'quehacemos') {
        const elementParentTop = this.elementServicios.nativeElement.offsetTop;
        $('html, body').animate({
          scrollTop: elementParentTop - 260
        }, time);
      }
      if (types === 'nosotros') {
        const elementParentTop = this.elementNosotros.nativeElement.offsetParent.offsetTop;
        $('html, body').animate({
          scrollTop: elementParentTop - 100
        }, time);
      }
      if (types === 'mision') {
        const elementParentTop = this.elementMision.nativeElement.offsetParent.offsetTop;
        $('html, body').animate({
          scrollTop: elementParentTop - 60
        }, time);
      }
      if (types === 'vision') {
        const elementParentTop = this.elementVision.nativeElement.offsetParent.offsetTop;
        $('html, body').animate({
          scrollTop: elementParentTop - 60
        }, time);
      }
      if (types === 'proyectos') {
        const elementParentTop = this.elementProyectos.nativeElement.offsetParent.offsetTop;
        $('html, body').animate({
          scrollTop: elementParentTop - 30
        }, time);
      }
      if (types === 'contacto') {
        const elementParentTop = this.elementContact.nativeElement.offsetTop;

        $('html, body').animate({
          scrollTop: elementParentTop - 50
        }, time);
      }
    } else {
      if (types === 'inicio') {
        $('html, body').animate({
          scrollTop: 0
        }, time);
      }
      if (types === 'quehacemos') {
        const elementParentTop = this.elementServicios.nativeElement.offsetTop;
        $('html, body').animate({
          scrollTop: elementParentTop - 330
        }, time);
      }
      if (types === 'nosotros') {
        const elementParentTop = this.elementNosotros.nativeElement.offsetParent.offsetTop;
        $('html, body').animate({
          scrollTop: elementParentTop - 170
        }, time);
      }
      if (types === 'mision') {
        const elementParentTop = this.elementMision.nativeElement.offsetParent.offsetTop;
        $('html, body').animate({
          scrollTop: elementParentTop - 130
        }, time);
      }
      if (types === 'vision') {
        const elementParentTop = this.elementVision.nativeElement.offsetParent.offsetTop;
        $('html, body').animate({
          scrollTop: elementParentTop - 130
        }, time);
      }
      if (types === 'proyectos') {
        const elementParentTop = this.elementProyectos.nativeElement.offsetParent.offsetTop;
        $('html, body').animate({
          scrollTop: elementParentTop - 120
        }, time);
      }
      if (types === 'contacto') {
        const elementParentTop = this.elementContact.nativeElement.offsetTop;

        $('html, body').animate({
          scrollTop: elementParentTop - 100
        }, time);
      }
    }
  }

}




// WEBPACK FOOTER //
// /home/federicblack/public_html/GrupoCristalino/src/app/app.component.ts